import React from 'react';
import Icon from '../Icon';
import classNames from '../../utility/classNames';

export default function PicturePlaceholder({ classes }) {
  return (
    <div className={classNames('h-full w-full', classes)}>
      <p
        className={classNames(
          'h-full flex items-center justify-center text-primary leading-4'
        )}
      >
        <Icon icon="FiImage" />
      </p>
    </div>
  );
}
